module.exports = __webpack_public_path__ + "img/22.566e2830.jpg";